// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-modal {
  --modalPadding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  text-align: left;
  color: #222;
  /* BACKDROP */
  /* GENERIC STUFF */
  /* BACKGROUND-IMAGE(S) */
  /* TYPES */
}
.srprs-modal.has-backdrop > .srprs-modalBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
  backdrop-filter: blur(2px);
}
.srprs-modal.has-backdrop.color-dark > .srprs-modalBackdrop {
  background-color: rgba(34, 34, 34, 0.95);
}
.srprs-modal.has-backdrop.color-layout > .srprs-modalBackdrop {
  background-color: var(--colorBackground);
  opacity: 0.95;
}
.srprs-modal .wrapper-modal {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translateX(-50%) translateY(-50%);
  width: 100vw;
  max-height: calc(100% - 40px);
  background-color: #fff;
  border-radius: 4px;
  -webkit-overflow-scrolling: touch; /* double check to enable momentum/inertia scrolling on iOS devices */
}
.srprs-modal .wrapper-modal::-webkit-scrollbar-track {
  background-color: #fff;
}
.srprs-modal .wrapper-modal .srprs-checkbox label {
  font-size: 16px;
}
.srprs-modal .wrapper-modal > header,
.srprs-modal .wrapper-modal > footer {
  display: flex;
  align-items: center;
  position: relative;
}
.srprs-modal .wrapper-modal > header:before, .srprs-modal .wrapper-modal > header:after,
.srprs-modal .wrapper-modal > footer:before,
.srprs-modal .wrapper-modal > footer:after {
  content: "";
  position: absolute;
}
.srprs-modal .wrapper-modal > header .srprs-icon,
.srprs-modal .wrapper-modal > footer .srprs-icon {
  width: 20px;
  height: 20px;
}
.srprs-modal .wrapper-modal > header {
  height: 50px;
  min-height: 50px;
  padding-right: var(--modalPadding);
  padding-left: var(--modalPadding);
  padding-top: 5px;
  font-size: 15px;
  font-weight: bold;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}
.srprs-modal .wrapper-modal > header:before {
  bottom: 0;
  left: var(--modalPadding);
  z-index: 3;
  width: calc(100% - var(--modalPadding) * 2);
  height: 1px;
  background-color: #e7e7e7;
}
.srprs-modal .wrapper-modal > header:after {
  bottom: calc(10px - var(--modalPadding));
  left: calc(var(--modalPadding) / 2);
  z-index: 2;
  width: calc(100% - (var(--modalPadding)));
  height: 10px;
  background-image: linear-gradient(to bottom, white 0%, rgba(255, 255, 255, 0) 100%);
}
.srprs-modal .wrapper-modal > header .icon {
  display: none;
}
.srprs-modal .wrapper-modal > header .type-textlink-uppercase span {
  font-weight: lighter;
}
.srprs-modal .wrapper-modal > header .type-textlink-uppercase:hover {
  transform: none;
}
.srprs-modal .wrapper-modal > header .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  width: calc(100% - 40px);
  text-transform: uppercase;
  user-select: none;
}
.srprs-modal .wrapper-modal > header .title span {
  font-weight: normal;
}
.srprs-modal .wrapper-modal > header .close {
  position: absolute;
  right: var(--modalPadding);
  cursor: pointer;
}
.srprs-modal .wrapper-modal > header .close .srprs-icon {
  bottom: 0;
  width: 20px;
  height: 20px;
}
.srprs-modal .wrapper-modal > header .srprs-button:hover .srprs-icon {
  transform: translate(-2px, 0);
}
.srprs-modal .wrapper-modal > header .srprs-button .srprs-icon {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  bottom: 1px;
  margin-right: 4px;
  width: 16px;
  height: 16px;
}
.srprs-modal .wrapper-modal > header .srprs-button + .title {
  position: relative;
  margin-left: 8px;
  padding-left: 9px; /* 8px + 1px for &:before which is below */
  width: calc(100% - 90px);
}
.srprs-modal .wrapper-modal > header .srprs-button + .title:before {
  content: "";
  position: absolute;
  top: -2px;
  left: 0;
  width: 1px;
  height: calc(100% + 4px);
  background-color: #e7e7e7;
}
.srprs-modal .wrapper-modal > .wrapper-inner {
  overflow: auto;
}
.srprs-modal .wrapper-modal > .wrapper-inner.giftcard-thanksgiving-modal {
  padding-top: 0;
}
.srprs-modal .wrapper-modal > .wrapper-inner.giftcard-thanksgiving-modal .content {
  padding-top: 0;
}
.srprs-modal .wrapper-modal > footer {
  position: relative;
  height: 80px;
  min-height: 80px;
  align-items: center;
  padding-right: var(--modalPadding);
  padding-left: var(--modalPadding);
  background-color: #e7e7e7;
}
.srprs-modal .wrapper-modal > footer:before {
  left: 0;
  z-index: 2;
  width: 100%;
  height: 10px;
  bottom: 80px;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, white 100%);
  pointer-events: none;
}
.srprs-modal .wrapper-modal > footer .legend {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  max-width: 10ch;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 16px;
}
.srprs-modal .wrapper-modal > footer .srprs-button {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  right: var(--modalPadding);
  max-width: 50%;
}
.srprs-modal .wrapper-modal > footer .srprs-button:only-child {
  max-width: none;
}
.srprs-modal .content {
  display: block;
  padding: var(--modalPadding);
}
.srprs-modal .content .srprs-list {
  margin-top: calc(0px - var(--modalPadding));
  margin-bottom: 16px;
}
.srprs-modal.has-backgroundImage .wrapper-modal {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}
.srprs-modal.has-backgroundImage .wrapper-modal > header:after, .srprs-modal.has-backgroundImage .wrapper-modal > header:before {
  background: none;
}
.srprs-modal.type-sticky .wrapper-modal {
  position: fixed;
  top: unset;
  bottom: 0;
  left: 0;
  transform: none;
  width: 100%;
}

@media screen and (max-height: 400px) {
  .srprs-modal .wrapper-modal > footer {
    display: none;
  }
}
@media screen and (min-width: 375px) {
  .srprs-modal .wrapper-modal > footer .legend {
    max-width: 20ch;
  }
}
@media screen and (min-width: 768px) {
  .srprs-modal {
    --modalPadding: 40px;
    /* SIZES - In this case, just widths. Height is controlled by using the power of flexbox and max-height */
    /* OVERFLOW? FINE BY ME, BUT HANDLE WITH CARE :) */
    /* TYPES */
  }
  .srprs-modal.size-s .wrapper-modal {
    max-width: 320px;
  }
  .srprs-modal.size-m .wrapper-modal {
    max-width: 480px;
  }
  .srprs-modal.size-l .wrapper-modal {
    max-width: 640px;
  }
  .srprs-modal.size-xl .wrapper-modal {
    max-width: 720px;
  }
  .srprs-modal.size-xxl .wrapper-modal {
    max-width: 1024px;
  }
  .srprs-modal.size-xxl .content {
    max-width: 840px;
  }
  .srprs-modal.has-contentoverflow .wrapper-modal > .wrapper-inner {
    overflow: visible;
  }
  .srprs-modal.type-sticky.animation-1 .wrapper-modal {
    will-change: auto;
    opacity: 0;
    transform: translateX(-50%) translateY(-50%) scale(0.5);
    animation-name: ModalWrapperIn2;
    animation-duration: 0.25s;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.4);
    animation-delay: 0.05s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
  }
  .srprs-modal.type-sticky .wrapper-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: unset;
  }
  .srprs-modal .wrapper-modal {
    box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .srprs-modal .wrapper-modal > header {
    height: 70px;
    min-height: 70px;
    margin-bottom: 5px;
  }
  .srprs-modal .wrapper-modal > header:before {
    display: none;
  }
  .srprs-modal .wrapper-modal > header:after {
    bottom: calc(30px - var(--modalPadding));
  }
  .srprs-modal .wrapper-modal > header .icon {
    display: inline-block;
  }
  .srprs-modal .wrapper-modal > header .icon .srprs-icon {
    width: 25px;
    height: 25px;
  }
  .srprs-modal .wrapper-modal > header .title {
    position: relative;
    width: calc(100% - 72px);
    margin-left: 8px;
    padding-left: 9px; /* 8px + 1px for &:before which is below */
    font-weight: bold;
    font-size: 16px;
  }
  .srprs-modal .wrapper-modal > header .title:before {
    content: "";
    position: absolute;
    top: -2px;
    left: 0;
    width: 1px;
    height: calc(100% + 4px);
    background-color: #e7e7e7;
  }
  .srprs-modal .wrapper-modal > footer {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    padding-right: 36px;
    padding-left: 36px;
    font-size: 18px;
  }
  .srprs-modal .wrapper-modal > footer .srprs-button {
    right: 36px;
  }
  .srprs-modal .wrapper-modal .srprs-list {
    margin-top: -12px;
  }
  .srprs-modal.is-headerless .wrapper-modal .content {
    padding-top: var(--modalPadding);
  }
}
@keyframes ModalWrapperIn1 {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(100%) translateZ(0);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) translateZ(0);
  }
}
@keyframes ModalWrapperIn2 {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-50%) scale(0.5);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(-50%) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Modal/Modal.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_truncate.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transition.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transform-center.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AA3LA;EACE,oBAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEE,gBAAA;EAEF,WAAA;EAEA,aAAA;EA4BA,kBAAA;EAmPA,wBAAA;EAiBA,UAAA;AArGF;AAzLI;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,0BAAA;AA2LN;AAxLM;EAEI,wCAAA;AAyLV;AApLM;EAEI,wCAAA;EAEF,aAAA;AAoLR;AA9KE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,4CAAA;EACA,YAAA;EACA,6BAAA;EAEE,sBAAA;EAGA,kBAAA;EAEF,iCAAA,EAAA,qEAAA;AA4KJ;AA3KI;EAEI,sBAAA;AA4KR;AAxKM;EACE,eAAA;AA0KR;AAvKI;;EAEE,aAAA;EACA,mBAAA;EACA,kBAAA;AAyKN;AAxKM;;;EAEE,WAAA;EACA,kBAAA;AA2KR;AAzKM;;EACE,WAAA;EACA,YAAA;AA4KR;AAtKI;EACE,YAAA;EACA,gBAAA;EAEE,kCAAA;EACA,iCAAA;EACA,gBAAA;EAGA,eAAA;EACA,iBAAA;EAIE,4BAAA;EACA,2BAAA;AAkKV;AA/JM;EAEE,SAAA;EACA,yBAAA;EACA,UAAA;EACA,2CAAA;EACA,WAAA;EAEE,yBAAA;AA+JV;AA5JM;EAEE,wCAAA;EACA,mCAAA;EACA,UAAA;EACA,yCAAA;EACA,YAAA;EAEE,mFAAA;AA4JV;AArJM;EACE,aAAA;AAuJR;AApJQ;EAEI,oBAAA;AAqJZ;AAlJQ;EACE,eAAA;AAoJV;AAjJM;EI7JJ,gBAAA;EACA,mBAAA;EACA,uBAAA;EJ8JM,qBAAA;EACA,wBAAA;EAEE,yBAAA;EAEF,iBAAA;AAkJR;AAjJQ;EAEI,mBAAA;AAkJZ;AA9IM;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AAgJR;AA/IQ;EACE,SAAA;EACA,WAAA;EACA,YAAA;AAiJV;AA5IU;EACE,6BAAA;AA8IZ;AA3IQ;EK3LJ,wBAAA;EACA,0BL2L0B;EK1L1B,oCAAA;EAEE,oBANqD;ELgMjD,WAAA;EAEE,iBAAA;EAEF,WAAA;EACA,YAAA;AA6IV;AA3IQ;EACE,kBAAA;EAEE,gBAAA;EAGA,iBAAA,EAAA,0CAAA;EAEF,wBAAA;AAyIV;AAvIU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EAEE,yBAAA;AAwId;AAlII;EACE,cAAA;AAoIN;AAnIM;EACE,cAAA;AAqIR;AApIQ;EACE,cAAA;AAsIV;AAlII;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EAEE,kCAAA;EACA,iCAAA;EAGA,yBAAA;AAiIR;AA/HM;EAEE,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAEE,mFAAA;EAMF,oBAAA;AA0HR;AAxHM;EInQJ,gBAAA;EACA,mBAAA;EACA,uBAAA;EJoQM,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EAEE,yBAAA;EAGA,eAAA;AAwHV;AArHM;EIjRJ,gBAAA;EACA,mBAAA;EACA,uBAAA;EJkRM,kBAAA;EACA,0BAAA;EACA,cAAA;AAwHR;AAvHQ;EACE,eAAA;AAyHV;AAnHE;EACE,cAAA;EACA,4BAAA;AAqHJ;AApHI;EAEI,2CAAA;EACA,mBAAA;AAqHR;AA9GI;EAEI,4BAAA;EACA,sBAAA;EACA,4BAAA;AA+GR;AA5GQ;EAEE,gBAAA;AA6GV;AArGI;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;AAuGN;;ACrZI;EDqTA;IACE,aAAA;EAoGJ;AACF;AC5aI;EDgVI;IACE,eAAA;EA+FR;AACF;ACjbI;EDyVF;IACE,oBAAA;IAEA,yGAAA;IA8BA,kDAAA;IAOA,UAAA;EAuDF;EA1FI;IACE,gBAAA;EA4FN;EAxFI;IACE,gBAAA;EA0FN;EAtFI;IACE,gBAAA;EAwFN;EApFI;IACE,gBAAA;EAsFN;EAlFI;IACE,iBAAA;EAoFN;EAlFI;IACE,gBAAA;EAoFN;EA9EI;IACE,iBAAA;EAgFN;EAzEM;IACE,iBAAA;IACA,UAAA;IACA,uDAAA;IAEE,+BAAA;IACA,yBArYM;IAsYN,gEArYO;IAsYP,sBAAA;IACA,6BAAA;IACA,4BAAA;EA0EV;EAtEI;IMrZJ,kBAAA;IAEE,QAHgC;IAOlC,SAAA;IACA,gCAAA;INiZM,aAAA;EA0EN;EAtEE;IOjZA,6CAAA;IPsZM,+BAAA;IACA,8BAAA;EAqER;EAlEI;IACE,YAAA;IACA,gBAAA;IAEE,kBAAA;EAmER;EAjEM;IACE,aAAA;EAmER;EAjEM;IACE,wCAAA;EAmER;EAjEM;IACE,qBAAA;EAmER;EAlEQ;IACE,WAAA;IACA,YAAA;EAoEV;EAjEM;IACE,kBAAA;IACA,wBAAA;IAEE,gBAAA;IAGA,iBAAA,EAAA,0CAAA;IAGA,iBAAA;IACA,eAAA;EA8DV;EA5DQ;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,wBAAA;IAEE,yBAAA;EA6DZ;EAxDI;IAGM,+BAAA;IACA,8BAAA;IAIF,mBAAA;IACA,kBAAA;IAGA,eAAA;EAmDR;EAjDM;IACE,WAAA;EAmDR;EAhDI;IAEI,iBAAA;EAiDR;EA3CM;IAEI,gCAAA;EA4CV;AACF;AArCA;EACE;IACE,UAAA;IACA,0DAAA;EAuCF;EArCA;IACE,UAAA;IACA,uDAAA;EAuCF;AACF;AApCA;EACE;IACE,UAAA;IACA,uDAAA;EAsCF;EApCA;IACE,UAAA;IACA,qDAAA;EAsCF;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n// TODO: make modal behave more like a dialog window and make separate - and both totally different - versions of modals for\n// - Homepage => Step 1 of the funnel\n// - Funnel => \"Collapsibles\" as designed by Stephan, see https://imgur.com/a/wHpc8\n//\n// Create a better solution for popping in and out transitions\n\n$animation-speed: 0.25s;\n$animation-easing: cubic-bezier(0.175, 0.885, 0.32, 1.4);\n\n.srprs-modal {\n  --modalPadding: #{section(padding-initial)};\n  //--modalPadding: padding(large);\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: z-index(modal);\n  width: 100%;\n  height: 100%;\n  text: {\n    align: left;\n  }\n  color: color(black);\n\n  /* BACKDROP */\n  &.has-backdrop {\n    > .srprs-modalBackdrop {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n      z-index: z-index(modalBackdrop);\n      backdrop-filter: blur(2px);\n    }\n    &.color-dark {\n      > .srprs-modalBackdrop {\n        background: {\n          color: rgba(color(black), 0.95);\n        }\n      }\n    }\n    &.color-layout {\n      > .srprs-modalBackdrop {\n        background: {\n          color: var(--colorBackground);\n        }\n        opacity: 0.95;\n      }\n    }\n  }\n\n  /* GENERIC STUFF */\n  .wrapper-modal {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    z-index: 999;\n    transform: translateX(-50%) translateY(-50%);\n    width: 100vw;\n    max-height: calc(100% - 40px);\n    background: {\n      color: color(white);\n    }\n    border: {\n      radius: 4px;\n    }\n    -webkit-overflow-scrolling: touch; /* double check to enable momentum/inertia scrolling on iOS devices */\n    &::-webkit-scrollbar-track {\n      background: {\n        color: color(white);\n      }\n    }\n    .srprs-checkbox {\n      label {\n        font-size: 16px;\n      }\n    }\n    > header,\n    > footer {\n      display: flex;\n      align-items: center;\n      position: relative;\n      &:before,\n      &:after {\n        content: '';\n        position: absolute;\n      }\n      .srprs-icon {\n        width: 20px;\n        height: 20px;\n        // path {\n        //   fill: color(black);\n        // }\n      }\n    }\n    > header {\n      height: 50px;\n      min-height: 50px;\n      padding: {\n        right: var(--modalPadding);\n        left: var(--modalPadding);\n        top: 5px;\n      }\n      font: {\n        size: 15px;\n        weight: bold;\n      }\n      border: {\n        top: {\n          right-radius: 4px;\n          left-radius: 4px;\n        }\n      }\n      &:before {\n        // divider-line\n        bottom: 0;\n        left: var(--modalPadding);\n        z-index: 3;\n        width: calc(100% - (var(--modalPadding) * 2));\n        height: 1px;\n        background: {\n          color: color(grey-light);\n        }\n      }\n      &:after {\n        // gradient\n        bottom: calc(10px - var(--modalPadding));\n        left: calc(var(--modalPadding) / 2);\n        z-index: 2;\n        width: calc(100% - (var(--modalPadding)));\n        height: 10px;\n        background: {\n          image: linear-gradient(\n            to bottom,\n            rgba(color(white), 1) 0%,\n            rgba(color(white), 0) 100%\n          );\n        }\n      }\n      .icon {\n        display: none;\n      }\n      .type-textlink-uppercase {\n        span {\n          font: {\n            weight: lighter;\n          }\n        }\n        &:hover {\n          transform: none;\n        }\n      }\n      .title {\n        @include truncate();\n\n        display: inline-block;\n        width: calc(100% - 40px);\n        text: {\n          transform: uppercase;\n        }\n        user-select: none;\n        span {\n          font: {\n            weight: normal;\n          }\n        }\n      }\n      .close {\n        position: absolute;\n        right: var(--modalPadding);\n        cursor: pointer;\n        .srprs-icon {\n          bottom: 0;\n          width: 20px;\n          height: 20px;\n        }\n      }\n      .srprs-button {\n        &:hover {\n          .srprs-icon {\n            transform: translate(-2px, 0);\n          }\n        }\n        .srprs-icon {\n          @include transition(0.25s);\n\n          bottom: 1px;\n          margin: {\n            right: 4px;\n          }\n          width: 16px;\n          height: 16px;\n        }\n        & + .title {\n          position: relative;\n          margin: {\n            left: 8px;\n          }\n          padding: {\n            left: 9px; /* 8px + 1px for &:before which is below */\n          }\n          width: calc(100% - 90px);\n\n          &:before {\n            content: '';\n            position: absolute;\n            top: -2px;\n            left: 0;\n            width: 1px;\n            height: calc(100% + 4px);\n            background: {\n              color: color(grey-light);\n            }\n          }\n        }\n      }\n    }\n    > .wrapper-inner {\n      overflow: auto;\n      &.giftcard-thanksgiving-modal {\n        padding-top: 0;\n        .content {\n          padding-top: 0;\n        }\n      }\n    }\n    > footer {\n      position: relative;\n      height: 80px;\n      min-height: 80px;\n      align-items: center;\n      padding: {\n        right: var(--modalPadding);\n        left: var(--modalPadding);\n      }\n      background: {\n        color: color(grey-light);\n      }\n      &:before {\n        // gradient\n        left: 0;\n        z-index: 2;\n        width: 100%;\n        height: 10px;\n        bottom: 80px;\n        background: {\n          image: linear-gradient(\n            to bottom,\n            rgba(color(white), 0) 0%,\n            rgba(color(white), 1) 100%\n          );\n        }\n        pointer-events: none;\n      }\n      .legend {\n        @include truncate();\n\n        display: inline-block;\n        position: relative;\n        max-width: 10ch;\n        cursor: pointer;\n        text: {\n          transform: uppercase;\n        }\n        font: {\n          size: 16px;\n        }\n      }\n      .srprs-button {\n        @include truncate();\n\n        position: absolute;\n        right: var(--modalPadding);\n        max-width: 50%;\n        &:only-child {\n          max-width: none;\n        }\n      }\n    }\n  }\n\n  .content {\n    display: block;\n    padding: var(--modalPadding);\n    .srprs-list {\n      margin: {\n        top: calc(0px - var(--modalPadding));\n        bottom: 16px;\n      }\n    }\n  }\n\n  /* BACKGROUND-IMAGE(S) */\n  &.has-backgroundImage {\n    .wrapper-modal {\n      background: {\n        repeat: no-repeat;\n        size: cover;\n        position: 50% 50%;\n      }\n      > header {\n        &:after,\n        &:before {\n          background: none;\n        }\n      }\n    }\n  }\n\n  /* TYPES */\n  &.type-sticky {\n    .wrapper-modal {\n      position: fixed;\n      top: unset;\n      bottom: 0;\n      left: 0;\n      transform: none;\n      width: 100%;\n    }\n  }\n}\n\n@include height-breakpoint(mobile-keyboard) {\n  .srprs-modal .wrapper-modal {\n    > footer {\n      display: none;\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-modal {\n    .wrapper-modal {\n      > footer {\n        .legend {\n          max-width: 20ch;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-modal {\n    --modalPadding: 40px;\n\n    /* SIZES - In this case, just widths. Height is controlled by using the power of flexbox and max-height */\n    &.size-s {\n      .wrapper-modal {\n        max-width: 320px;\n      }\n    }\n    &.size-m {\n      .wrapper-modal {\n        max-width: 480px;\n      }\n    }\n    &.size-l {\n      .wrapper-modal {\n        max-width: 640px;\n      }\n    }\n    &.size-xl {\n      .wrapper-modal {\n        max-width: 720px;\n      }\n    }\n    &.size-xxl {\n      .wrapper-modal {\n        max-width: 1024px;\n      }\n      .content {\n        max-width: 840px;\n      }\n    }\n\n    /* OVERFLOW? FINE BY ME, BUT HANDLE WITH CARE :) */\n    &.has-contentoverflow {\n      .wrapper-modal > .wrapper-inner {\n        overflow: visible;\n      }\n    }\n\n    /* TYPES */\n    &.type-sticky {\n      &.animation-1 {\n        .wrapper-modal {\n          will-change: auto;\n          opacity: 0;\n          transform: translateX(-50%) translateY(-50%) scale(0.5);\n          animation: {\n            name: ModalWrapperIn2;\n            duration: $animation-speed; // what a weird var\n            timing-function: $animation-easing; // what a weird var\n            delay: 0.05s; // because the visitor will notice this\n            fill-mode: forwards;\n            iteration-count: 1;\n          }\n        }\n      }\n      .wrapper-modal {\n        @include transform-center();\n\n        bottom: unset;\n      }\n    }\n\n    .wrapper-modal {\n      @include box-shadow();\n\n      border: {\n        bottom: {\n          right-radius: 4px;\n          left-radius: 4px;\n        }\n      }\n      > header {\n        height: 70px;\n        min-height: 70px;\n        margin: {\n          bottom: 5px;\n        }\n        &:before {\n          display: none;\n        }\n        &:after {\n          bottom: calc(30px - var(--modalPadding));\n        }\n        .icon {\n          display: inline-block;\n          .srprs-icon {\n            width: 25px;\n            height: 25px;\n          }\n        }\n        .title {\n          position: relative;\n          width: calc(100% - 72px);\n          margin: {\n            left: 8px;\n          }\n          padding: {\n            left: 9px; /* 8px + 1px for &:before which is below */\n          }\n          font: {\n            weight: bold;\n            size: 16px;\n          }\n          &:before {\n            content: '';\n            position: absolute;\n            top: -2px;\n            left: 0;\n            width: 1px;\n            height: calc(100% + 4px);\n            background: {\n              color: color(grey-light);\n            }\n          }\n        }\n      }\n      > footer {\n        border: {\n          bottom: {\n            right-radius: 4px;\n            left-radius: 4px;\n          }\n        }\n        padding: {\n          right: 36px;\n          left: 36px;\n        }\n        font: {\n          size: 18px;\n        }\n        .srprs-button {\n          right: 36px;\n        }\n      }\n      .srprs-list {\n        margin: {\n          top: -12px;\n        }\n      }\n    }\n    &.is-headerless {\n      .wrapper-modal {\n        .content {\n          padding: {\n            top: var(--modalPadding);\n          }\n        }\n      }\n    }\n  }\n}\n\n@keyframes ModalWrapperIn1 {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(100%) translateZ(0);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0) translateZ(0);\n  }\n}\n\n@keyframes ModalWrapperIn2 {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-50%) scale(0.5);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(-50%) scale(1);\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin truncate() {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n","@charset \"UTF-8\";\n\n@mixin transition($transition-duration, $transition-delay: 0s) {\n  transition: {\n    property: all;\n    duration: $transition-duration;\n    timing-function: ease-out;\n    @if $transition-delay {\n      delay: $transition-delay;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin transform-center($offsetTop: 50%) {\n  position: absolute;\n  @if ($offsetTop) {\n    top: $offsetTop;\n  } @else {\n    top: 50%;\n  }\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
